import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Es un libro físico?',
    a: 'No, es un programa 100% digital con acceso inmediato. Podrá verlo desde su celular, tablet o computadora al instante.'
  }, {
    q: '¿Por qué tan barato?',
    a: 'Es una oferta de lanzamiento para llegar a más dueños y ayudar a la mayor cantidad de perros posible a recuperar su paz mental.'
  }, {
    q: '¿Funciona en perros adultos?',
    a: 'Sí, el protocolo se basa en biología pura, funciona a cualquier edad. El sistema nervioso responde a los mismos estímulos sin importar los años del perro.'
  }, {
    q: '¿Qué pasa si no me gusta?',
    a: 'Tiene garantía de 14 días. Si no ve resultados después de aplicar el protocolo, le devolvemos el 100% de su inversión sin hacer preguntas.'
  }];
  return <section className="py-10 px-4 bg-cloud-grey" data-id="element-50">
      <div className="max-w-3xl mx-auto" data-id="element-51">
        <h2 className="text-3xl font-bold font-serif text-center text-gray-900 mb-10" data-id="element-52">
          Preguntas Frecuentes
        </h2>
        <div className="space-y-4" data-id="element-53">
          {faqs.map((faq, index) => <div key={index} className="bg-gray-900 rounded-[20px] overflow-hidden border border-gray-800" data-id="element-54">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full p-6 text-left flex justify-between items-center text-white focus:outline-none" data-id="element-55">
                <span className="font-bold text-lg pr-4" data-id="element-56">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-brand-gold flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-57" />
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-58">
                <div className="p-6 pt-0 text-gray-300 leading-relaxed" data-id="element-59">
                  {faq.a}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}